export default function registerExclusiveGateway (lf) {
  lf.register('exclusiveGateway', ({ PolygonNode, PolygonNodeModel, h }) => {
    class Node extends PolygonNode {
      getIconShape () {
        const {model} = this.props
        const {
          x,
          y,width, height
        } = model
        const {stroke} = model.getNodeStyle()
        return h(
          "svg",{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":width,"height":height,"viewBox":"0 0 40 40","fill":"none"},
          h("g",{"opacity":"1","transform":"translate(0 0)  rotate(0 20 20)"}),
          h("g",{"mask":"url(#bg-mask-0)"}),
          h("path",{"id":"分组 1","fill-rule":"evenodd","style":"fill:#808080","transform":"translate(15.185017465300888 12.00009374999999)  rotate(0 4.8149990798495566 7.99990625)","opacity":"1","d":"M4.63 0C1.86 0.31 0.32 1.51 0.01 3.61C-0.05 4.29 0.28 4.66 1.02 4.72C1.39 4.78 1.7 4.5 1.95 3.89C2.32 2.59 3.21 1.94 4.63 1.94C6.36 2.07 7.28 2.93 7.41 4.53C7.41 6.01 6.4 6.26 5.86 6.7C5.17 7.27 4.71 7.84 4.16 8.81C3.7 9.63 3.62 11.38 3.62 11.38C3.62 12.12 3.95 12.49 4.63 12.49C5.25 12.49 5.59 12.12 5.65 11.38C5.65 11.38 5.73 9.42 6.53 8.55C7.42 7.57 9.57 6.88 9.63 4.35C9.38 1.7 7.72 0.25 4.63 0Z M3.34581 14.7143C3.34581 15.4243 3.92581 16.0043 4.63581 16.0043C5.34581 16.0043 5.92581 15.4243 5.92581 14.7143C5.92581 14.0043 5.34581 13.4243 4.63581 13.4243C3.92581 13.4243 3.34581 14.0043 3.34581 14.7143Z "}),
          h("path",{"id":"分组 1","fill-rule":"evenodd","style":"fill:#808080","transform":"translate(2.421875 2.421875)  rotate(0 17.575129234374998 17.575129234374998)","opacity":"1","d":"M3.3952 17.5752L17.5752 31.7552L31.7552 17.5752L17.5752 3.3952L3.3952 17.5752Z M0 17.58L17.58 35.15L35.15 17.58L17.58 0L0 17.58Z "}),
          h("mask",{"id":"bg-mask-0","fill":"white"}),
          h("use",{"xlink:href":"#path_0"}),
          h("rect",{"id":"path_0","x":"0","y":"0","width":"40","height":"40"}),
        )
      }
      getShape () {
        const {model} = this.props
        const {width, height, x, y, points} = model
        const {fill, fillOpacity, strokeWidth, stroke, strokeOpacity,} = model.getNodeStyle()
        const transform = `matrix(1 0 0 1 ${x - width / 2} ${y - height / 2})`
        const pointsPath = points.map(point => point.join(',')).join(' ')
        return h(
          'g',
          {
            transform
          },
          [
            h("svg",{"xmlns":"http://www.w3.org/2000/svg","version":"1.1"}),
            h("rect",{"width":width,"height":height,"style":"fill:rgba(255,255,255,0);stroke-width:1;stroke:rgba(0,0,0,0)"}),
            this.getIconShape()
          ]
        )
      }
    }
    class Model extends PolygonNodeModel {
      constructor (data, graphModel) {
        data.text = {
          value: (data.text && data.text.value) || '',
          x: data.x,
          y: data.y + 50
        }
        super(data, graphModel)
        // 右键菜单自由配置，也可以通过边的properties或者其他属性条件更换不同菜单
        this.menu = [
          {
            className: 'lf-menu-delete',
            text: '删除',
            callback (node) {
              // const comfirm = window.confirm('你确定要删除吗？')
              lf.deleteNode(node.id)
            }
          },
          {
            text: '修改',
            className: 'lf-menu-item',
            callback (node) {
              lf.editText(node.id)
            }
          },
          {
            text: '复制',
            className: 'lf-menu-item',
            callback (node) {
              lf.cloneNode(node.id)
            }
          }
        ]
      }
      initNodeData(data) {
        super.initNodeData(data)
        const lenght = 35
        this.points = [
          [lenght, 0],
          [lenght * 2, lenght],
          [lenght, lenght * 2],
          [0, lenght]
        ]
      }
      // 自定义锚点样式
      getAnchorStyle() {
        const style = super.getAnchorStyle();
        style.hover.r = 8;
        style.hover.fill = "rgb(24, 125, 255)";
        style.hover.stroke = "rgb(24, 125, 255)";
        return style;
      }
    }
    return {
      view: Node,
      model: Model
    }
  })
}



// WEBPACK FOOTER //
// ./src/components/Admin/Flow/bpmn/registerNode/registerExclusiveGateway.js